import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DialogCloseResult, DialogService } from '@progress/kendo-angular-dialog';
import { CalamityService } from 'app/calamity/calamity.service';
import { IntakeService } from 'app/intake/intake-services/intake.service';
import { CedNotificationService } from 'ced-ng-library';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AddCalamityActionComponent } from '../add-calamity-action/add-calamity-action.component';
import { CalamityActionService } from '../calamity-action.service';
@Component({
  selector: 'app-calamity-actions',
  templateUrl: './calamity-actions-list.component.html',
  styleUrls: ['./calamity-actions-list.component.scss']
})
export class CalamityActionsListComponent implements OnInit {
  public calamityId: string ;
  dataSource : any[]= [];
  ouId : string ;
  index : number;
  private _subject$: Subject<boolean> = new Subject();
  public selectedCalamityAction = null;
  constructor(private dialogService: DialogService,
    private cd: ChangeDetectorRef,
    private calamityActionService: CalamityActionService,
    private cedNotificationService: CedNotificationService,
    private calamityService : CalamityService,
    private intakeService : IntakeService) { }

  ngOnInit() {
    this.getCalamityId();
    this.getCalamityActions();
  }

  getCalamityId(){
    this.calamityService.calId$.pipe(takeUntil(this._subject$))
    .subscribe(res=> {
       this.calamityId=res;
    },
    (error) => {
        this.cedNotificationService.error("NOTIFICATIONS.GET_CALAMITY_BY_ID");
    });
  }

  getDate(date){
    return this.getLocaleDate(date);
   }
 
   getLocaleDate(date: Date) {
     if(date!=null && (this.isIsoDate(date.toString()) ||  date.toString().indexOf('GMT') ==-1 ))
     {
       return this.intakeService.getLocalDate(date);
     }
     return date;
   }
 
   isIsoDate(dateStringToCompare) {
     return new Date(dateStringToCompare).toISOString() === dateStringToCompare;
  }

  getCalamityActions(){
     this.calamityActionService
    .getActionsByCalamityId(this.calamityId)
    .pipe(takeUntil(this._subject$))
    .subscribe((data : any) => { 
      if ((data !=null) || (data !=undefined) || (data !="") ){
        let actionsList =[];
        data.forEach(element => {
          try  {
          element.claCreatedDate = this.getDate (element.claCreatedDate);
          element.claLastModifiedDate = this.getDate (element.claLastModifiedDate);
          element.claFollowUpDate=this.getDate(element.claFollowUpDate);
          
          let otherItems = JSON.parse(element.claFreeText);
          element.claContactWith = otherItems.claContactWith;
          if(otherItems.claManagedBy!= undefined && otherItems.claManagedBy!= null){
              element.claAssignee= otherItems.claManagedBy.fullName;
            }
          element.claClosedDateAndTime=this.getDate(otherItems.claClosedDateAndTime);
          element.claAssociatedToHelpPlan = otherItems.claAssociatedToHelpPlan;
          element.claHelpPlan=otherItems.claHelpPlan;
          element.claComment = otherItems.claComment;
          element.notesNumber = element.calamityActionNotes.length
          actionsList.push(element);
          }
           catch (e) {
          }
        }); 
        this.dataSource = [...actionsList];          
      }
      this.cd.detectChanges();
    },
    (error) => {
        this.cedNotificationService.error("NOTIFICATIONS.GET_ACTIONS_FOR_CALAMITY");
    }
    );
  } 
    

  openDetails() { 
    if(this.selectedCalamityAction != null)
    this.openDialog(this.selectedCalamityAction);
  }
 
  onCellClick($event) {
    this.selectedCalamityAction = $event.dataItem
    this.index = $event.rowIndex;
  }

  openDialog(calamityAction){
    const dialogRef = this.dialogService.open({
      content: AddCalamityActionComponent
    });
     dialogRef.content.instance.calamityActionToUpdate = calamityAction;
     dialogRef.content.instance.addAction = true;
    dialogRef.result.subscribe((calamityactionUpdated)=>{
      if(!(calamityactionUpdated instanceof DialogCloseResult)){
        this.getCalamityActions();
        this.selectedCalamityAction = null; 
      }
    });
  }

  addCalamityAction(){
    const dialogRef = this.dialogService.open({
      content : AddCalamityActionComponent,
    });
     dialogRef.content.instance.addAction = true;
    dialogRef.result.subscribe((calamityaction)=>{
      if(!(calamityaction instanceof DialogCloseResult)){
        this.getCalamityActions();
      }
    });
  }
}
